const messages = {
  subtitle: "Spoznajte naš Bridgestone tim",
  title: "Kontakt storitev",
  description: "Dobrodošli v kontakt storitev",
  teams: {
    direct: "Neposredno",
    indirect: "Posredno",
    tyre: "Ekipa trgovine s pneumatikami",
    car: "Ekipa avtohiš",
    lkw: "Ekipa tovornjakov",
    em_otr: "Ekipa EM/OTR",
    farm_tractor: "Ekipa kmetijskih traktorjev",
    bandag: "Bandag ekipa",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
